module.exports = __webpack_public_path__ + "static/media/Nekedra J.1ce8de3e.png";